import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import CourseCatalogPage from './pages/CourseCatalogPage';
import CourseDetailsPage from './pages/CourseDetailsPage';
import StudentDashboardPage from './pages/StudentDashboardPage';
import InstructorDashboardPage from './pages/InstructorDashboardPage';
import CreateCoursePage from './pages/CreateCoursePage';
import ProfilePage from './pages/ProfilePage';
import AnalyticsPage from './pages/AnalyticsPage';
import HelpCenterPage from './pages/HelpCenterPage';
import ContactPage from './pages/ContactPage';
import AboutUsPage from './pages/AboutUsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import FAQPage from './pages/FAQPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen flex flex-col">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/courses" element={<CourseCatalogPage />} />
              <Route path="/courses/:id" element={<CourseDetailsPage />} />
              
              {/* Student Routes */}
              <Route 
                path="/dashboard" 
                element={
                  <ProtectedRoute requireStudent>
                    <StudentDashboardPage />
                  </ProtectedRoute>
                } 
              />
              
              {/* Instructor Routes */}
              <Route 
                path="/instructor-dashboard" 
                element={
                  <ProtectedRoute requireInstructor>
                    <InstructorDashboardPage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/courses/create" 
                element={
                  <ProtectedRoute requireInstructor>
                    <CreateCoursePage />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/courses/:id/edit" 
                element={
                  <ProtectedRoute requireInstructor>
                    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Edit Course</h2>
                        <p className="text-gray-600 mb-6">Course editing form will be implemented here.</p>
                        <button 
                          onClick={() => window.history.back()}
                          className="w-full bg-primary-600 text-white py-2 px-4 rounded-md hover:bg-primary-700 transition-colors duration-200"
                        >
                          Go Back
                        </button>
                      </div>
                    </div>
                  </ProtectedRoute>
                } 
              />
              <Route 
                path="/courses/:id/lessons" 
                element={
                  <ProtectedRoute requireInstructor>
                    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full">
                        <h2 className="text-2xl font-bold text-gray-900 mb-4">Manage Lessons</h2>
                        <p className="text-gray-600 mb-6">Lesson management interface will be implemented here.</p>
                        <button 
                          onClick={() => window.history.back()}
                          className="w-full bg-primary-600 text-white py-2 px-4 rounded-md hover:bg-primary-700 transition-colors duration-200"
                        >
                          Go Back
                        </button>
                      </div>
                    </div>
                  </ProtectedRoute>
                } 
              />
              
              {/* Profile Route */}
              <Route 
                path="/profile" 
                element={
                  <ProtectedRoute>
                    <ProfilePage />
                  </ProtectedRoute>
                } 
              />
              
              {/* Analytics Route */}
              <Route 
                path="/analytics" 
                element={
                  <ProtectedRoute requireInstructor>
                    <AnalyticsPage />
                  </ProtectedRoute>
                } 
              />

              {/* Support & Information Pages */}
              <Route path="/help" element={<HelpCenterPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/about" element={<AboutUsPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/terms" element={<TermsOfServicePage />} />
              <Route path="/faq" element={<FAQPage />} />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
